import { gql } from '__generated__';

export default gql(`
  mutation EditScanner($input: EditScannerInput!) {
    editScanner(input: $input) {
      ...ScannerAttributes
    }
  }
`);
